<template>
  <section class="faq">
    <div class="container">
      <h2><slot>Frequently asked questions</slot></h2>

      <div class="items">
        <ul>
          <faq-item
            v-for="option in qa.slice(0, 3)"
            :key="option.id"
            :option="option"
          ></faq-item>
        </ul>
        <ul>
          <faq-item
            v-for="option in qa.slice(3)"
            :key="option.id"
            :option="option"
          ></faq-item>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import FaqItem from './FaqItem/FaqItem';

export default {
  components: {
    FaqItem,
  },
  props: {
    faq: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      default: [
        {
          id: 1,
          question: 'What is Proxify?',
          answer:
            'Proxify is a Swedish IT company with a global reach; a community that comprises talent at the very top of their field. We assist in helping startups and established companies around the world to work efficiently and effectively with talented developers and designers on a remote basis.',
        },
        {
          id: 2,
          question: 'What happens after I get invited to the Proxify network?',
          answer:
            'If we assume that you stand out in our comprehensive vetting process and you’re invited to join the network, then what typically happens after is that you get matched to a project. This generally happens within 2 weeks but it can go much quicker than this. You’ll also be given access to your account login, where you’ll be able to see current opportunities and apply to them directly yourself.',
        },
        {
          id: 3,
          question: 'Is it the same as having a full-time job?',
          answer:
            'Our hope is that you won’t want to nor need to look for other work. If you’re at the top of your field, we want you to join for the long-term and we want you to work full-time with us and our clients. However, there are no guarantees in the way one considers with fixed, traditional employment. But we’re sure that you share our view that remote work is the way forward, especially if you want to have a say in how you work, where you work from, as well as the type of projects you work on.',
        },
        {
          id: 4,
          question:
            'What if there are no projects I can be matched with immediately?',
          answer:
            'With such a high number of candidates and talented individuals joining the network, it’s natural that this can happen. However, an increasing flow of interest in a range of technologies makes us confident that we’ll be able to place you on a project in a very short period of time - normally within 2 weeks.',
        },
        {
          id: 5,
          question: 'How do I get paid?',
          answer:
            'It’s simple, you send an invoice each month for the previous month’s work and we pay this timely, either via SWIFT (international bank transfer) or other payment services, such as Revolut, Stripe, PayPal etc. Assuming no extenuating circumstances, you will always get paid on time. We do not rely on payment from our clients to pay our members.',
        },
        {
          id: 6,
          question: 'What if I don’t like a project that I start working on?',
          answer:
            'As you’ve seen in the application form you just completed, we care about your desire when it comes to the type of projects you’ll work on. We’re well aware of the costs that come with a wrong match so it is our mission to make sure you’re placed on the right project from the start. If not? Then we’re committed to finding you another project to hop on to, of course.',
        },
      ],
    };
  },
  computed: {
    qa() {
      return this.faq.length > 0 ? this.faq : this.default;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './FaqSection.scss';
</style>
